export default __webpack_public_path__ + "static/BETTERIRL_GREEN-6bdb81096e5aaa99562d13a6f1fa18b6.png";